<template>
  <div class="w-full bor rounded-[5px] overflow-hidden box-border bg-[#fff]">
    <div class="flex items-center justify-between h-[55px] md:h-[84px] px-[10px] md:px-[20px]">
      <!-- <img
        v-if="logo"
        class="w-[148px] md-w-[282px] max-h-[35px] md:max-h-[60px]"
        :src="logo"
        alt=""
      /> -->

      <div
        class="text-[#555] text-[20px] font-600 p-[10px] no-warp flex items-center"
        @click="handelRouer"
      >
        <div class="w-[35px] mt-[8px] mr-[5px]">
          <svg
            t="1775188267358"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="8228"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <path
              d="M974.848 813.056h-143.9744l-35.0208-281.3952c-0.6144-5.5296 3.2768-10.6496 8.8064-11.4688 5.5296-0.6144 10.6496 3.2768 11.4688 8.8064l32.768 263.5776H954.368V354.5088c0-97.4848-79.4624-176.9472-176.9472-176.9472L446.464 178.176c-5.7344 0-10.24-4.5056-10.24-10.24s4.5056-10.24 10.24-10.24l330.9568-0.6144c108.9536 0 197.4272 88.4736 197.4272 197.4272V813.056zM486.6048 813.056H354.304l-35.2256-247.1936c-0.8192-5.5296 3.072-10.8544 8.6016-11.6736 5.5296-0.8192 10.8544 3.072 11.6736 8.6016l32.768 229.5808H466.944l10.8544-251.0848c0.2048-5.7344 4.9152-10.0352 10.6496-9.8304 5.7344 0.2048 10.0352 5.12 9.8304 10.6496L486.6048 813.056z"
              fill=""
              p-id="8229"
            ></path>
            <path
              d="M652.288 643.6864c-95.6416 0-162.6112-15.36-166.7072-16.384-5.5296-1.2288-9.0112-6.7584-7.5776-12.288s6.7584-8.8064 12.288-7.5776c1.4336 0.4096 152.1664 34.816 324.1984 0 5.5296-1.024 10.8544 2.4576 12.0832 7.9872 1.2288 5.5296-2.4576 10.8544-7.9872 12.0832-60.0064 12.288-116.9408 16.1792-166.2976 16.1792z"
              fill=""
              p-id="8230"
            ></path>
            <path
              d="M802.816 751.616h-0.2048l-56.32-1.2288-22.9376-111.616c-1.2288-5.5296 2.4576-10.8544 7.9872-12.0832 5.5296-1.2288 10.8544 2.4576 12.0832 7.9872l19.6608 95.6416 39.936 0.8192c5.7344 0.2048 10.24 4.7104 10.0352 10.4448-0.2048 5.5296-4.7104 10.0352-10.24 10.0352z"
              fill=""
              p-id="8231"
            ></path>
            <path
              d="M164.6592 331.9808m-22.7328 0a22.7328 22.7328 0 1 0 45.4656 0 22.7328 22.7328 0 1 0-45.4656 0Z"
              fill=""
              p-id="8232"
            ></path>
            <path
              d="M325.632 745.472l-73.3184-0.4096-33.5872-228.1472c-0.2048-1.2288-0.6144-2.2528-1.6384-2.8672-0.6144-0.6144-1.4336-0.6144-2.2528-0.4096-14.9504 3.4816-33.792 2.048-49.7664-3.2768C122.88 641.024 136.8064 671.1296 142.336 677.2736c1.6384 1.8432 3.2768 2.2528 3.2768 2.2528l8.8064-1.8432 17.2032 52.0192-9.216 3.4816c-30.72 11.4688-56.7296 11.0592-77.4144-1.4336-32.5632-19.6608-38.2976-61.8496-38.5024-63.6928V416.9728c0-149.504 121.6512-271.1552 271.1552-271.1552 3.2768 0 78.2336 0.6144 117.3504 49.7664 22.1184 27.648 27.8528 64.9216 17.408 110.3872l-0.4096 1.2288c-28.672 78.6432-88.4736 161.792-147.456 168.96-19.8656 2.4576-48.9472-3.072-74.9568-41.984-3.072-4.7104-1.8432-11.0592 2.8672-14.1312s11.0592-1.8432 14.1312 2.8672c16.1792 24.3712 34.816 35.4304 55.5008 32.9728 48.128-5.7344 104.0384-83.1488 130.4576-155.0336 8.8064-38.7072 4.3008-69.8368-13.5168-92.3648-32.9728-41.5744-100.5568-41.984-101.376-41.984-138.24 0-250.6752 112.4352-250.6752 250.6752v249.0368c0.6144 4.3008 6.3488 34.6112 28.8768 48.128 13.1072 7.7824 29.9008 8.8064 50.176 2.8672l-5.9392-18.0224c-4.096-1.024-8.8064-3.4816-13.1072-8.3968-20.8896-23.7568-13.5168-90.112 22.3232-197.4272l3.6864-11.264 10.6496 5.3248c13.312 6.7584 32.9728 9.216 46.6944 6.144 6.5536-1.4336 13.312-0.2048 18.8416 3.8912 5.5296 4.096 9.216 10.24 10.0352 17.2032l30.9248 210.1248 55.5008 0.2048c5.7344 0 10.24 4.7104 10.24 10.24 0 5.7344-4.7104 10.24-10.24 10.24z"
              fill=""
              p-id="8233"
            ></path>
          </svg>
        </div>
        {{ web_name }}
      </div>
      <div
        class="w-[252px] md:w-[320px] flex items-center justify-center gap-[10px] md:gap-[20px] h-[40px] mr-[10px]"
      >
        <van-field
          class="h-[30px] py-[6px] px-[10px] mr-[10px]"
          style="background-color: #f5f5f5; border-radius: 20px"
          v-model="vod_name"
          @click-right-icon="onSearch"
          right-icon="search"
          placeholder="请输入关键词..."
        />

        <div class="w-[35px]" @click="handelcd">
          <svg
            t="1711002620780"
            class="icon"
            viewBox="0 0 200.27 199.25"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="18561"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            fill="#555"
          >
            <path
              class="cls-1"
              d="M62.27,133.26l6.91,14.18q3.09-7,5.82-14.57l5.27,2.42,4.18-1.87,6.33,13.71q2.93-7,5.63-14.57l8.44,3.59q-3.95,11.72-8.75,22.5l8.2,18.28-8.83,4.38L90.74,169.9q-3.79,7.5-7.93,14.53-1.76-1.37-3.48-2.62l-4.18,2.07L69.1,169.51a174.15,174.15,0,0,1-9.41,15.78q-2-1.84-4.77-4.14v13H44.45V120.52h71v60q0,6.05-2.3,9.32a9,9,0,0,1-6.46,3.81,143,143,0,0,1-15.53.55,104.49,104.49,0,0,0-2.42-10.94q5.55.55,11.25.55,5,0,5-4.92V130.29H54.92v6.8Zm-7.34,5.39v35.66a173.88,173.88,0,0,0,9.18-16.13Q59.49,147.95,54.92,138.65Zm25.27,6.76q-2.74,6.91-5.7,13.28l5.43,11.68q3-5.74,5.94-12Z"
              transform="translate(-0.14)"
            >
              <animate
                attributeName="visibility"
                from="hidden"
                to="visible"
                dur="1s"
                repeatCount="indefinite"
              />
            </path>
            <path
              class="cls-1"
              d="M123,185.29,121,174l9.3-2.11V146.38H121.8v-10.7h8.52V117.4H140.7v18.28h8.52v10.7H140.7v23l8.91-2.3q-.08,3.2,0,11.09Zm20.39-4.69h10V133.49h10.31V180.6h6.88v-63h10.7v22.5h15.23v10.39H181.33V180.6h17.5V191H143.44Z"
              transform="translate(-0.14)"
            >
              <animate
                attributeName="visibility"
                from="hidden"
                to="visible"
                dur="1s"
                repeatCount="indefinite"
              />
            </path>
            <path
              class="cls-1"
              d="M115.72,160.38v7.27a49.2,49.2,0,0,1-8.4,12.93,54.23,54.23,0,0,0,11.84,3.71,90.54,90.54,0,0,0-4.69,9.53,55.21,55.21,0,0,1-14.88-6.52,54.13,54.13,0,0,1-13.95,6.91q-1.21-1.91-3.36-5.7-1.29.16-2.5.23v6.33H70.25V189.6l-26.87,2.66L42,183.51l5.86-.31v-27H41.42v-7.66h77.66v7.66H79.78v24.38l4.38-.47q-.31,2-.51,4A46.54,46.54,0,0,0,91.58,181a55.22,55.22,0,0,1-8.2-10.12l4.53-3H82v-7.5Zm-65-40h59.06v24.69H50.72Zm6.72,40.23H70.25v-4.37H57.44Zm0,10.31H70.25v-4.37H57.44Zm12.81,10.59v-4.65H57.44v5.66ZM99,126.63H61.5V130H99Zm0,12.19v-3.36H61.5v3.36Zm.27,37a32.19,32.19,0,0,0,6.45-8H91.34A39,39,0,0,0,99.27,175.85Z"
              transform="translate(-0.14)"
            >
              <animate
                attributeName="visibility"
                from="visible"
                to="hidden"
                dur="1s"
                repeatCount="indefinite"
              />
            </path>
            <path
              class="cls-1"
              d="M161.5,133.27H150.8q2.15,1,8.36,3.67-1.29,2-4,6h8v8.75H148.06v5.08h13.75v8.75H148.06v18.83a9.54,9.54,0,0,1-1.54,5.74,6.81,6.81,0,0,1-4.3,2.68,59.9,59.9,0,0,1-10.18.57,42.74,42.74,0,0,0-1.56-8.79L128.84,188a51.46,51.46,0,0,0-8.36-3.91,91.7,91.7,0,0,0,6.8-17.19L136,169.6a118.53,118.53,0,0,1-5,13.67q1.91.16,3.83.16,3,0,3-3.52V165.54H123.22v-8.75h14.69v-5.08H122V143h8.4q-1.64-3.2-3.4-6.09l8.52-3.44q3.12,5.2,5.23,9.53h3.44q3.87-6.52,5.31-9.69H123.38v-8.75h13.91q-1.05-2.85-2-5.16l10.78-2q1.13,3,2.34,7.11H161.5ZM199,153.2h-5.94v40.63H182.75V153.2h-6.87v4.45q0,24.73-10.7,37.73-5.31-4.61-9.84-7.81a27.09,27.09,0,0,0,7-9.8l-8,4.49a109.43,109.43,0,0,0-5.94-11.56l7.5-3.75a86.17,86.17,0,0,1,6.45,10.74q3.24-7.62,3.24-18.48V124.05q17.81-1.8,29-5.7L199,128.59a140.42,140.42,0,0,1-23.12,4V143H199Z"
              transform="translate(-0.14)"
            >
              <animate
                attributeName="visibility"
                from="visible"
                to="hidden"
                dur="1s"
                repeatCount="indefinite"
              />
            </path>
            <path
              class="cls-1"
              d="M16.9,179.69a15,15,0,0,1-2.46-8.48V28.63A14.36,14.36,0,0,1,28.79,14.29h14a.32.32,0,0,1,.32.32V71.55A14.27,14.27,0,0,0,57.35,85.84H142.9a14.63,14.63,0,0,0,14.63-14.63V14.61a.32.32,0,0,1,.32-.32h14a14.32,14.32,0,0,1,14.3,14.33V94a6,6,0,0,0,6,6h2.29a6,6,0,0,0,6-6V28.61A28.61,28.61,0,0,0,171.8,0H29.07A28.93,28.93,0,0,0,.14,28.93V171.66A28.62,28.62,0,0,0,20.24,199,6,6,0,0,0,28,193.23v-2a6.1,6.1,0,0,0-4-6A14.19,14.19,0,0,1,16.9,179.69ZM58.2,14.78h84.24a.32.32,0,0,1,.32.32V70.75a.32.32,0,0,1-.32.32H58.2a.32.32,0,0,1-.32-.32V15.1A.32.32,0,0,1,58.2,14.78Z"
              transform="translate(-0.14)"
            />
          </svg>
        </div>
        <!-- <van-icon color="#f2990d" size="35" name="wap-nav" @click="handelcd" /> -->
      </div>
    </div>
    <!-- 导航 -->
    <div
      class="flex justify-between items-center h-[50px] overflow-hidden box-border px-[10px] bg-[#fff]"
    >
      <div class="text-[#555] text-[18px] flex items-center mr-[10px]">
        <van-icon name="arrow-double-left" @click="scrollLeft" />
      </div>
      <div
        class="flex items-center gap-[16px] overflow-x-auto scroll-container whitespace-nowrap px-[12px] py-[10px] bg-[#fff]"
        id="containers"
      >
        <div
          v-for="(item, index) in typeClass"
          :key="index"
          :id="'btn' + index"
          class="shrink-0 h-[30px] leading-[30px] px-[10px] text-[14px] rounded-[999px] user-select-none text-center transition-all duration-200"
          :class="[
            navIndex == index
              ? 'bg-[#ff8a3d] text-[#fff] font-[500] shadow-[0_2px_8px_rgba(255,138,61,0.25)]'
              : 'bg-[#f3f3f3] text-[#555] font-[400]'
          ]"
          @click="onClickNav(item, index, 'type')"
        >
          {{ item.type_name }}
        </div>
      </div>
      <div class="text-[#555] text-[rem] flex items-center ml-[0.1rem]">
        <van-icon name="arrow-double-right" @click="scrollRight" />
      </div>
    </div>
    <!-- <div
      class="scroll-container scroll-nav w-full h-[40px] md:h-[50px] overflow-auto flex items-center flex-nowrap gap-[40px] px-[20px] bg-[#f2990d] box-border text-[#fff]"
    >
      <div
        v-for="(item, index) in 10"
        :key="index"
        :id="'btn' + index"
        class="flex-shrink-0 btn-item text-[14px] md:text-[15px]"
      >
        {{ '哈哈哈' }}
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { pcScrollX } from '@/utils/common'
const router = useRouter()
const props = defineProps({
  logo: {
    type: String,
    default: ''
  },
  typeClass: {
    type: Array,
    default: () => []
  },
  web_name: {
    type: String,
    default: ''
  },
  isIndex: {
    type: Boolean,
    default: false
  },
  isHome: {
    type: Boolean,
    default: false
  }
})
const vod_name = ref('')

onMounted(() => {
  sessionStorage.getItem('vod_name') && (vod_name.value = sessionStorage.getItem('vod_name'))
})

// const page = ref(1)
const loading = ref(false)
const navIndex = ref(0)
const onClickNav = (item, index, type, num = 0) => {
  if (index == 0) {
    sessionStorage.removeItem('isIndex')
    localStorage.removeItem('page')
    if (props.isHome) {
      // console.log('刷新首页')

      location.reload(false)
    } else {
      router.push('/')
    }
    return
  }
  sessionStorage.setItem('isIndex', index)
  if (type) {
    localStorage.removeItem('page')
  }
  if (props.isIndex && type) {
    router.back()
  } else {
    emits('onNav', { item, num })
  }
  // page.value = 1
  navIndex.value = index
  loading.value = true
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
  nextTick(() => {
    const dom = document.getElementById('btn' + navIndex.value)
    const container = document.getElementById('containers') // 指定容器
    container.scrollTo({
      left: dom.offsetLeft - container.offsetWidth / 2 + dom.offsetWidth / 2, // 让按钮在容器中居中
      behavior: 'smooth' // 平滑滚动
    })
  })

  // tx(item.id)
  // if (item.id == 0) {
  //   // isIndex.value = 1
  //   router.push({
  //     path: 'home'
  //   })
  // } else {
  //   router.push({
  //     path: 'listView',
  //     query: {
  //       id: item.id
  //     }
  //   })
  // }
}
const emits = defineEmits(['handelcd', 'onNav', 'onSearch'])
const handelcd = () => {
  emits('handelcd')
}
const onSearch = () => {
  if (props.isIndex) {
    sessionStorage.setItem('vod_name', vod_name.value)
    // router.back()
    router.push('/')
  } else {
    emits('onSearch', vod_name.value)
  }
}
// const handelShow = () => {
//   console.log('handelShow1')

//   emits('handelShow')
// }
const homeClassNav = (page) => {
  const index = sessionStorage.getItem('isIndex')
  // console.log(index, props.typeClass, 'index')
  if (index) {
    onClickNav(props.typeClass[+index], +index, '', page)
  }
}
const scrollDistance = 200 // 每次滚动距离
function scrollLeft() {
  const scrollBox = document.getElementById('containers')
  scrollBox.scrollBy({ left: -scrollDistance, behavior: 'smooth' })
}

function scrollRight() {
  const scrollBox = document.getElementById('containers')
  scrollBox.scrollBy({ left: scrollDistance, behavior: 'smooth' })
}

const handelRouer = () => {
  sessionStorage.removeItem('isIndex')
  localStorage.removeItem('page')
  if (props.isHome) {
    location.reload()
  } else {
    router.push('/')
  }
}
defineExpose({ homeClassNav })
</script>

<style scoped>
:deep(.van-cell) {
  line-height: normal;
}
/* 隐藏 Chrome、Safari 和 Edge 滚动条 */
.scroll-container::-webkit-scrollbar {
  display: none;
}
.scroll-container {
  user-select: none;
}
</style>
